<template>
  <div class="flex flex-col" :data-testid="testId">
    <span
      class="inline-flex w-fit items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium"
      :class="QUEUE_TONE_PILL_CLASS[stageTone(stage)]"
    >
      {{ PACKAGE_STAGE_LABELS[stage] }}
    </span>
    <div v-if="showSteps" class="mt-1.5 flex gap-[3px]" aria-hidden="true">
      <i
        v-for="(step, index) in steps"
        :key="index"
        class="block h-[5px] w-[18px] rounded-sm"
        :class="STEP_CLASS[step]"
        :data-testid="`${testId}-step-${index}`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { QUEUE_TONE_PILL_CLASS } from '@/components/designSystem/QueueViews/types'
import type { PackageStage } from '@/Network/Types/Responses/AntecipeAffiliateResponses'

import { PACKAGE_STAGE_LABELS, stageSteps, stageTone } from '../labels'
import type { StageStep } from '../labels'

const props = withDefaults(
  defineProps<{ stage: PackageStage; showSteps?: boolean; testId?: string }>(),
  { showSteps: true, testId: 'affiliate-stage-cell' }
)

const STEP_CLASS: Record<StageStep, string> = {
  done: 'bg-primary',
  current: 'bg-blue-500',
  todo: 'bg-lightGray30',
  canceled: 'bg-[#7F7F8E]'
}

const steps = computed(() => stageSteps(props.stage))
</script>
